<div class="EFApp">
    @if (!isUnderMaintenance()) {
        <div class="EFApp-Inner">
            @if (!isInIframe) {
                <div class="EFApp-Inner-Header">
                    <app-pg-header [alwaysShow]="true" [noTasks]="true" [noUser]="true" appName="Finder"></app-pg-header>
                </div>
            }
            <div class="EFApp-Inner-Content">
                @if (!isSwitchingLanguage && !needConsent) {
                    <div>
                        <router-outlet></router-outlet>
                    </div>
                }
            </div>
            @if (!isInIframe) {
                <div class="EFApp-Inner-Footer">
                    <app-pg-footer></app-pg-footer>
                </div>
            }
        </div>
        @if (externalLinkUrl != null) {
            <div class="EFModal EFModal--ExternalLink pg-animation-slideup">
                <div class="EFModal-Header border-bottom">
                    <div>
                    </div>
                    <div>
                        <button class="btn btn-link" (click)="externalLinkUrl = null">
                            <span>{{ 'experience-finder.app.nav-close-external' | locTranslate }}</span>
                            <i class="fa-regular fa-times"></i>
                        </button>
                    </div>
                </div>
                <div class="EFModal-Body">
                    <iframe sandbox="" [src]="externalLinkUrl | safe:'resourceUrl'"></iframe>
                </div>
            </div>
        }
    }
    <app-pg-maintenance></app-pg-maintenance>
    @if (!isInIframe) {
        <app-pg-cookie-consent></app-pg-cookie-consent>
    }
</div>